'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');
var nthHookContextAnalytics = require('@narvar/nth-hook-context-analytics');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var nthHookTheme = require('@narvar/nth-hook-theme');
var nthHookSettings = require('@narvar/nth-hook-settings');
var nthKitDynamicLayoutNext = require('@narvar/nth-kit-dynamic-layout-next');
var Panel = require('@narvar/nth-block-panel');
var PanelHeader = require('@narvar/nth-bit-panel-header');
var nthHookContextPage = require('@narvar/nth-hook-context-page');
var useOrderTracking = require('@narvar/nth-hook-order-tracking');
var nthHookGlobalSettings = require('@narvar/nth-hook-global-settings');
var Carousel = require('@narvar/nth-bundle-carousel');
var ItemTile = require('./components/ItemTile.js');
var PrefetchData = require('./PrefetchData.js');
var GiftTrackingMessage = require('./components/GiftTrackingMessage.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Panel__default = /*#__PURE__*/_interopDefaultLegacy(Panel);
var PanelHeader__default = /*#__PURE__*/_interopDefaultLegacy(PanelHeader);
var useOrderTracking__default = /*#__PURE__*/_interopDefaultLegacy(useOrderTracking);
var Carousel__default = /*#__PURE__*/_interopDefaultLegacy(Carousel);

const {
  FeatureLayout,
  CategoryConditionCategory
} = nthKitDynamicLayoutNext.LayoutTree;
const ItemsInThisShipment = ({
  featureName,
  layout = FeatureLayout.PORTRAIT,
  fixedPanelHeight
}) => {
  const {
    state: {
      category
    }
  } = nthHookContextPage.usePageContext();
  const logEvent = nthHookContextAnalytics.useAnalyticsPost();
  const isLandscape = layout === FeatureLayout.LANDSCAPE;
  const slidesToScrollAndShow = !isLandscape ? 1 : 2;
  const isGiftExperience = category === CategoryConditionCategory.SHARING;
  const {
    itemsInThisShipment
  } = nthHookSettings.useSettings();
  const {
    showCarouselDots
  } = itemsInThisShipment || {
    showCarouselDots: true
  };
  const {
    itemsInShipmentPanelTitle,
    itemsInShipmentItemTitle,
    itemsInShipmentAttribute0,
    itemsInShipmentAttribute1,
    itemsInShipmentAttribute2,
    itemsInShipmentAttribute3
  } = nthHookTranslations.useTranslations();
  const itemTextTemplates = {
    itemsInShipmentItemTitle,
    itemsInShipmentAttribute0,
    itemsInShipmentAttribute1,
    itemsInShipmentAttribute2,
    itemsInShipmentAttribute3
  };
  const {
    panelcontainerNoneNone: panelContainerStyle
  } = nthHookTheme.useTheme();
  const {
    giftSharingEnabled
  } = nthHookGlobalSettings.useGlobalSettings();
  const {
    getCurrentShipment,
    query
  } = useOrderTracking__default["default"]();
  const orderTrackingData = query?.data?.orderTracking;
  const currentShipment = getCurrentShipment();
  React.useEffect(() => {
    logEvent({
      eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_ITEMS_IN_THIS_SHIPMENT,
      eventFeature: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_ITEMS_IN_THIS_SHIPMENT,
      eventType: nthHookContextAnalytics.NarvarEventTypes.COMPONENT_RENDER,
      feature: featureName,
      pageComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_ITEMS_IN_THIS_SHIPMENT,
      trackLayout: layout
    });
  },
  // TODO: Make this dependency array exhaustive
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  const {
    shipments = []
  } = orderTrackingData?.orders[0] || {};
  if (!currentShipment || currentShipment.type === 'RETURN' && currentShipment.status === 'JUSTSHIPPED' && shipments.length > 1) return null;
  const {
    items
  } = currentShipment;
  if (items.length === 0) return null;

  // group items in pairs so we can display 2 per carousel tile
  const itemChunks = items.length === slidesToScrollAndShow && slidesToScrollAndShow === 2 ? [[items[0]], [items[1]]] : items.reduce((allItemChunks, _, index, arr) => {
    if (index % 2 === 0) {
      const [itemChunk0, itemChunk1] = arr.slice(index, index + 2);
      if (itemChunk0) {
        allItemChunks.push([itemChunk0, itemChunk1]);
      }
    }
    return allItemChunks;
  }, []);
  return /*#__PURE__*/React__default["default"].createElement(Panel__default["default"], {
    featureName: featureName,
    header: /*#__PURE__*/React__default["default"].createElement(PanelHeader__default["default"], {
      featureName: featureName
    }, itemsInShipmentPanelTitle),
    sOuter: {
      boxSizing: 'border-box',
      ...panelContainerStyle,
      overflowX: 'hidden',
      height: fixedPanelHeight || panelContainerStyle && panelContainerStyle.height || '100%'
    },
    sInner: {
      height: fixedPanelHeight ? 'auto' : '100%',
      maxHeight: fixedPanelHeight ? '100%' : 'auto'
    }
  }, isGiftExperience && giftSharingEnabled ? /*#__PURE__*/React__default["default"].createElement(GiftTrackingMessage["default"], {
    featureName: featureName,
    isLandscape: isLandscape
  }) : /*#__PURE__*/React__default["default"].createElement(Carousel__default["default"], {
    itemsCount: itemChunks.length,
    slickProps: {
      dots: showCarouselDots || false,
      slidesToScroll: slidesToScrollAndShow,
      slidesToShow: slidesToScrollAndShow,
      infinite: false
    },
    carouselContainerStyles: {
      margin: '1rem'
    }
  }, (Array.isArray(itemChunks) ? itemChunks : []).map(([itemChunk0, itemChunk1]) => /*#__PURE__*/React__default["default"].createElement("div", {
    key: `${itemChunk0?.productSku ?? ''} ${itemChunk1?.productSku ?? ''}`
  }, /*#__PURE__*/React__default["default"].createElement(ItemTile["default"], {
    itemInfo: itemChunk0,
    itemTextTemplates: itemTextTemplates,
    featureName: featureName
  }), itemChunk1 && /*#__PURE__*/React__default["default"].createElement(ItemTile["default"], {
    itemInfo: itemChunk1,
    itemTextTemplates: itemTextTemplates,
    featureName: featureName
  })))));
};
const ItemsInThisShipmentWithData = nthHookGlobalSettings.withGlobalSettingsProvider(nthHookSettings.withSettingsProvider(nthHookTranslations.withTranslationsProvider(nthHookTheme.withThemeProvider(ItemsInThisShipment, {
  themeTokens: ['panelcontainerNoneNone']
}), {
  translationKeys: ['itemsInShipmentPanelTitle', 'itemsInShipmentItemTitle', 'itemsInShipmentAttribute0', 'itemsInShipmentAttribute1', 'itemsInShipmentAttribute2', 'itemsInShipmentAttribute3']
}), {
  settingsRequested: `
        itemsInThisShipment {
          showCarouselDots
        }
      `
}), {
  globalSettingsRequested: `giftSharingEnabled`
});
const ItemsInThisShipmentlWithPrefetchedData = ({
  featureName,
  ...props
}) => /*#__PURE__*/React__default["default"].createElement(PrefetchData["default"], {
  featureName: featureName
}, /*#__PURE__*/React__default["default"].createElement(ItemsInThisShipmentWithData, _extends__default["default"]({
  featureName: featureName
}, props)));

exports.ItemTile = ItemTile["default"];
exports["default"] = ItemsInThisShipmentlWithPrefetchedData;
